// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  --pro-primary: #201157;
  --pro-primary-text: #ffffff;
  --pro-dark: #201157;
  --pro-accent: #EB266A;
  --pro-name: #201157;
  --pro-body: #555555;
  --pro-card-bg: #f5f5fa;
  --pro-bg: #f6f3ff;
  --pro-btn-bg: #201157;
  --pro-btn-text: #ffffff;
  --pro-ring: #201157;
}

ion-toolbar {
  --border-width: 0 !important;
  --background: var(--pro-primary);
  --color: var(--pro-primary-text);
}

ion-title p {
  font-weight: 600;
  font-size: 17px;
  margin: 0;
}

.pro-banner {
  width: 100%;
  height: 120px;
  background: var(--pro-primary);
  border-radius: 0 0 32px 32px;
  position: relative;
}

.pro-head {
  text-align: center;
  margin-top: -68px;
  padding: 0 20px;
  position: relative;
  z-index: 2;
}

.pro-avatar-wrap {
  display: flex;
  justify-content: center;
  margin-bottom: 12px;
}

.pro-avatar-frame {
  position: relative;
  width: 120px;
  height: 120px;
  border-radius: 50%;
  padding: 4px;
  background: var(--pro-ring);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
}
.pro-avatar-frame ion-avatar {
  width: 100%;
  height: 100%;
  margin: 0;
}

.pro-avatar-img {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  object-fit: cover;
  cursor: pointer;
}

.pro-avatar-placeholder {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  background: var(--pro-card-bg);
  display: flex;
  align-items: center;
  justify-content: center;
}
.pro-avatar-placeholder ion-icon {
  width: 48px;
  height: 48px;
  opacity: 0.25;
}

.pro-online {
  position: absolute;
  bottom: 6px;
  right: 6px;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: #4ade80;
  border: 3px solid #fff;
}

.pro-meta {
  margin-bottom: 12px;
}

.pro-name {
  font-size: 28px;
  font-weight: 700;
  color: var(--pro-name);
  margin: 0 0 4px;
  line-height: 1.15;
  letter-spacing: -0.3px;
  word-break: break-word;
  text-align: center;
}

.pro-role {
  font-size: 15px;
  font-weight: 400;
  color: var(--pro-body);
  margin: 0;
  opacity: 0.8;
  line-height: 1.4;
  word-break: break-word;
  text-align: center;
}

.pro-social {
  display: flex;
  justify-content: center;
  gap: 4px;
  flex-wrap: wrap;
  margin-bottom: 4px;
}

.pro-social-btn {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  border: 1px solid var(--pro-primary);
  background: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.2s ease, transform 0.2s ease;
}
.pro-social-btn:hover {
  background: color-mix(in srgb, var(--pro-primary) 10%, transparent);
  transform: scale(1.12);
}
.pro-social-btn ion-icon {
  width: 18px;
  height: 18px;
  color: var(--pro-primary);
}

.pro-body {
  padding: 8px 16px 32px;
  max-width: 640px;
  margin: 0 auto;
  animation: proFadeUp 0.35s ease both;
}

@keyframes proFadeUp {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.pro-actions {
  display: flex;
  gap: 8px;
  justify-content: center;
  margin: 16px 0;
  flex-wrap: wrap;
}

.pro-action-btn {
  --border-color: var(--pro-primary);
  --color: var(--pro-primary);
  --border-radius: 24px;
  font-weight: 500;
  font-size: 14px;
  min-height: 40px;
  text-transform: none;
  margin: 0;
}

.pro-section {
  margin-top: 20px;
}

.pro-section + .pro-section {
  position: relative;
  padding-top: 20px;
}
.pro-section + .pro-section::before {
  content: "";
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  width: calc(100% - 40px);
  height: 1px;
  background: var(--pro-body);
  opacity: 0.12;
}

.pro-card {
  background: #ffffff;
  border-radius: 16px;
  padding: 20px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  border: 1px solid rgba(0, 0, 0, 0.04);
}

.pro-card-body {
  font-size: 15px;
  line-height: 1.65;
  color: var(--pro-body);
  font-weight: 400;
}
.pro-card-body * {
  max-width: 100%;
  word-break: break-word;
}

.pro-card--inline {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 20px;
}

.pro-inline-icon {
  font-size: 20px;
  color: var(--pro-primary);
  flex-shrink: 0;
}

.pro-inline-link {
  font-size: 14px;
  color: var(--pro-btn-bg);
  text-decoration: none;
  word-break: break-all;
}
.pro-inline-link:hover {
  text-decoration: underline;
}

.pro-cf-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.pro-cf-item {
  display: flex;
  align-items: flex-start;
  gap: 12px;
}

.pro-cf-icon {
  flex-shrink: 0;
  width: 20px;
  height: 20px;
  font-size: 20px;
  color: var(--pro-primary);
  margin-top: 2px;
  display: flex;
  align-items: center;
  justify-content: center;
}

i.pro-cf-icon {
  font-size: 20px;
  font-style: normal;
}

.pro-cf-text {
  flex: 1;
  min-width: 0;
}

.pro-cf-label {
  display: block;
  font-size: 11px;
  font-weight: 600;
  color: var(--pro-body);
  text-transform: uppercase;
  letter-spacing: 0.06em;
  margin-bottom: 2px;
  opacity: 0.6;
}

.pro-cf-value {
  font-size: 15px;
  line-height: 1.4;
  color: var(--pro-name);
  font-weight: 500;
  word-break: break-word;
}

.pro-doc-row {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 12px 0;
  cursor: pointer;
  transition: background 0.2s ease;
}
.pro-doc-row:hover {
  background: var(--pro-card-bg);
  border-radius: 10px;
  margin: 0 -8px;
  padding: 12px 8px;
}

.pro-doc-row + .pro-doc-row {
  border-top: 1px solid rgba(0, 0, 0, 0.04);
}

.pro-doc-icon {
  flex-shrink: 0;
  width: 40px;
  height: 40px;
  border-radius: 10px;
  background: var(--pro-card-bg);
  display: flex;
  align-items: center;
  justify-content: center;
}
.pro-doc-icon img {
  width: 22px;
  height: 22px;
  object-fit: contain;
}

.pro-doc-info {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 1px;
}

.pro-doc-name {
  font-size: 14px;
  font-weight: 500;
  color: var(--pro-name);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.pro-doc-type {
  font-size: 12px;
  font-weight: 400;
  color: var(--pro-body);
  opacity: 0.6;
}

.pro-doc-arrow {
  font-size: 16px;
  color: var(--pro-body);
  opacity: 0.3;
  flex-shrink: 0;
}

.pro-att-row {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 0;
  cursor: pointer;
  transition: background 0.2s ease;
}
.pro-att-row:hover {
  background: var(--pro-card-bg);
  border-radius: 10px;
  padding: 10px 8px;
  margin: 0 -8px;
}

.pro-att-row + .pro-att-row {
  border-top: 1px solid rgba(0, 0, 0, 0.04);
}

.pro-att-avatar {
  width: 44px;
  height: 44px;
  flex-shrink: 0;
  margin: 0;
}

.pro-att-placeholder {
  opacity: 0.4;
}

.pro-att-info {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.pro-att-name {
  font-size: 15px;
  font-weight: 600;
  color: var(--pro-name);
}

.pro-att-role {
  font-size: 13px;
  color: var(--pro-body);
  opacity: 0.7;
}

.pro-att-arrow {
  font-size: 16px;
  color: var(--pro-body);
  opacity: 0.3;
}

.pro-sessions-card {
  padding: 16px 20px;
}

.pro-session-date {
  font-size: 12px;
  font-weight: 600;
  color: var(--pro-body);
  text-transform: uppercase;
  letter-spacing: 0.08em;
  padding: 16px 0 8px;
  opacity: 0.6;
}

.pro-session-row {
  display: flex;
  gap: 14px;
  padding: 10px 0;
  cursor: pointer;
  border-left: 2px solid rgba(0, 0, 0, 0.06);
  padding-left: 14px;
  margin-left: 0;
  transition: border-color 0.2s ease;
}
.pro-session-row:hover {
  border-left-color: var(--pro-primary);
}

.pro-session-track-dot {
  flex-shrink: 0;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-top: 5px;
}

.pro-session-body {
  flex: 1;
  min-width: 0;
}

.pro-session-name {
  font-size: 15px;
  font-weight: 600;
  color: var(--pro-name);
  line-height: 1.3;
}

.pro-session-time {
  font-size: 13px;
  color: var(--pro-body);
  opacity: 0.7;
  margin-top: 2px;
}

.pro-session-location {
  font-size: 12px;
  color: var(--pro-btn-bg);
  margin-top: 4px;
  display: flex;
  align-items: center;
  gap: 4px;
}
.pro-session-location ion-icon {
  width: 14px;
  height: 14px;
}

.pro-loader {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 200px;
}

@media screen and (min-width: 768px) {
  ::ng-deep ion-content {
    --background: var(--pro-bg);
  }
  .pro-banner {
    height: 160px;
    border-radius: 0 0 40px 40px;
  }
  .pro-head {
    margin-top: -88px;
    padding: 0 40px;
  }
  .pro-avatar-frame {
    width: 140px;
    height: 140px;
    padding: 5px;
  }
  .pro-avatar-placeholder ion-icon {
    width: 56px;
    height: 56px;
  }
  .pro-name {
    font-size: 34px;
  }
  .pro-role {
    font-size: 17px;
  }
  .pro-social {
    gap: 6px;
  }
  .pro-social-btn {
    width: 40px;
    height: 40px;
    border-width: 1.5px;
  }
  .pro-social-btn ion-icon {
    width: 20px;
    height: 20px;
  }
  .pro-body {
    padding: 12px 40px 48px;
    max-width: 720px;
  }
  .pro-card {
    border-radius: 20px;
    padding: 24px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  }
  .pro-cf-list {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 20px;
  }
  .pro-actions {
    gap: 12px;
  }
  .pro-action-btn {
    min-height: 44px;
    font-size: 15px;
  }
  .pro-session-row {
    padding: 12px 0 12px 16px;
  }
  .pro-session-name {
    font-size: 16px;
  }
}
@media (prefers-reduced-motion: reduce) {
  .pro-body {
    animation: none;
  }
  .pro-social-btn,
  .pro-doc-row,
  .pro-att-row {
    transition: none !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/modules/profile/profile.page.scss"],"names":[],"mappings":"AAAA;EACE,sBAAA;EACA,2BAAA;EACA,mBAAA;EACA,qBAAA;EACA,mBAAA;EACA,mBAAA;EACA,sBAAA;EACA,iBAAA;EACA,qBAAA;EACA,uBAAA;EACA,mBAAA;AACF;;AAEA;EACE,4BAAA;EACA,gCAAA;EACA,gCAAA;AACF;;AAEA;EACE,gBAAA;EACA,eAAA;EACA,SAAA;AACF;;AAEA;EACE,WAAA;EACA,aAAA;EACA,8BAAA;EACA,4BAAA;EACA,kBAAA;AACF;;AAEA;EACE,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,kBAAA;EACA,UAAA;AACF;;AAEA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;AACF;;AAEA;EACE,kBAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,YAAA;EACA,2BAAA;EACA,0CAAA;AACF;AACE;EACE,WAAA;EACA,YAAA;EACA,SAAA;AACJ;;AAGA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;AAAF;;AAGA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,8BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAAF;AAEE;EACE,WAAA;EACA,YAAA;EACA,aAAA;AAAJ;;AAIA;EACE,kBAAA;EACA,WAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,sBAAA;AADF;;AAIA;EACE,mBAAA;AADF;;AAIA;EACE,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,sBAAA;EACA,kBAAA;AADF;;AAIA;EACE,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,SAAA;EACA,YAAA;EACA,gBAAA;EACA,sBAAA;EACA,kBAAA;AADF;;AAIA;EACE,aAAA;EACA,uBAAA;EACA,QAAA;EACA,eAAA;EACA,kBAAA;AADF;;AAIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,oCAAA;EACA,uBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,qDAAA;AADF;AAGE;EACE,mEAAA;EACA,sBAAA;AADJ;AAIE;EACE,WAAA;EACA,YAAA;EACA,yBAAA;AAFJ;;AAMA;EACE,sBAAA;EACA,gBAAA;EACA,cAAA;EACA,oCAAA;AAHF;;AAMA;EACE;IAAO,UAAA;IAAY,2BAAA;EADnB;EAEA;IAAK,UAAA;IAAY,wBAAA;EAEjB;AACF;AAAA;EACE,aAAA;EACA,QAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;AAEF;;AACA;EACE,kCAAA;EACA,2BAAA;EACA,qBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,SAAA;AAEF;;AACA;EACE,gBAAA;AAEF;;AACA;EACE,kBAAA;EACA,iBAAA;AAEF;AAAE;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,SAAA;EACA,2BAAA;EACA,wBAAA;EACA,WAAA;EACA,2BAAA;EACA,aAAA;AAEJ;;AAEA;EACE,mBAAA;EACA,mBAAA;EACA,aAAA;EACA,0CAAA;EACA,qCAAA;AACF;;AAEA;EACE,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,gBAAA;AACF;AACE;EACE,eAAA;EACA,sBAAA;AACJ;;AAGA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;AAAF;;AAGA;EACE,eAAA;EACA,yBAAA;EACA,cAAA;AAAF;;AAGA;EACE,eAAA;EACA,wBAAA;EACA,qBAAA;EACA,qBAAA;AAAF;AAEE;EACE,0BAAA;AAAJ;;AAIA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AADF;;AAIA;EACE,aAAA;EACA,uBAAA;EACA,SAAA;AADF;;AAIA;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,yBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AADF;;AAIA;EACE,eAAA;EACA,kBAAA;AADF;;AAIA;EACE,OAAA;EACA,YAAA;AADF;;AAIA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;EACA,sBAAA;EACA,kBAAA;EACA,YAAA;AADF;;AAIA;EACE,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,gBAAA;EACA,sBAAA;AADF;;AAIA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;EACA,eAAA;EACA,gCAAA;AADF;AAGE;EACE,8BAAA;EACA,mBAAA;EACA,cAAA;EACA,iBAAA;AADJ;;AAKA;EACE,yCAAA;AAFF;;AAKA;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,8BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAFF;AAIE;EACE,WAAA;EACA,YAAA;EACA,mBAAA;AAFJ;;AAMA;EACE,OAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AAHF;;AAMA;EACE,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAHF;;AAMA;EACE,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,YAAA;AAHF;;AAMA;EACE,eAAA;EACA,sBAAA;EACA,YAAA;EACA,cAAA;AAHF;;AAMA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;EACA,eAAA;EACA,gCAAA;AAHF;AAKE;EACE,8BAAA;EACA,mBAAA;EACA,iBAAA;EACA,cAAA;AAHJ;;AAOA;EACE,yCAAA;AAJF;;AAOA;EACE,WAAA;EACA,YAAA;EACA,cAAA;EACA,SAAA;AAJF;;AAOA;EACE,YAAA;AAJF;;AAOA;EACE,OAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AAJF;;AAOA;EACE,eAAA;EACA,gBAAA;EACA,sBAAA;AAJF;;AAOA;EACE,eAAA;EACA,sBAAA;EACA,YAAA;AAJF;;AAOA;EACE,eAAA;EACA,sBAAA;EACA,YAAA;AAJF;;AAOA;EACE,kBAAA;AAJF;;AAOA;EACE,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;EACA,sBAAA;EACA,mBAAA;EACA,YAAA;AAJF;;AAOA;EACE,aAAA;EACA,SAAA;EACA,eAAA;EACA,eAAA;EACA,0CAAA;EACA,kBAAA;EACA,cAAA;EACA,kCAAA;AAJF;AAME;EACE,qCAAA;AAJJ;;AAQA;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;AALF;;AAQA;EACE,OAAA;EACA,YAAA;AALF;;AAQA;EACE,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,gBAAA;AALF;;AAQA;EACE,eAAA;EACA,sBAAA;EACA,YAAA;EACA,eAAA;AALF;;AAQA;EACE,eAAA;EACA,wBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;AALF;AAOE;EACE,WAAA;EACA,YAAA;AALJ;;AASA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;AANF;;AASA;EACE;IACE,2BAAA;EANF;EASA;IACE,aAAA;IACA,4BAAA;EAPF;EAUA;IACE,iBAAA;IACA,eAAA;EARF;EAWA;IACE,YAAA;IACA,aAAA;IACA,YAAA;EATF;EAYA;IACE,WAAA;IACA,YAAA;EAVF;EAaA;IACE,eAAA;EAXF;EAcA;IACE,eAAA;EAZF;EAeA;IACE,QAAA;EAbF;EAgBA;IACE,WAAA;IACA,YAAA;IACA,mBAAA;EAdF;EAgBE;IACE,WAAA;IACA,YAAA;EAdJ;EAkBA;IACE,uBAAA;IACA,gBAAA;EAhBF;EAmBA;IACE,mBAAA;IACA,aAAA;IACA,0CAAA;EAjBF;EAoBA;IACE,aAAA;IACA,8BAAA;IACA,SAAA;EAlBF;EAqBA;IACE,SAAA;EAnBF;EAsBA;IACE,gBAAA;IACA,eAAA;EApBF;EAuBA;IACE,yBAAA;EArBF;EAwBA;IACE,eAAA;EAtBF;AACF;AAyBA;EACE;IACE,eAAA;EAvBF;EA0BA;;;IAGE,2BAAA;EAxBF;AACF","sourcesContent":[":host {\n  --pro-primary: #201157;\n  --pro-primary-text: #ffffff;\n  --pro-dark: #201157;\n  --pro-accent: #EB266A;\n  --pro-name: #201157;\n  --pro-body: #555555;\n  --pro-card-bg: #f5f5fa;\n  --pro-bg: #f6f3ff;\n  --pro-btn-bg: #201157;\n  --pro-btn-text: #ffffff;\n  --pro-ring: #201157;\n}\n\nion-toolbar {\n  --border-width: 0 !important;\n  --background: var(--pro-primary);\n  --color: var(--pro-primary-text);\n}\n\nion-title p {\n  font-weight: 600;\n  font-size: 17px;\n  margin: 0;\n}\n\n.pro-banner {\n  width: 100%;\n  height: 120px;\n  background: var(--pro-primary);\n  border-radius: 0 0 32px 32px;\n  position: relative;\n}\n\n.pro-head {\n  text-align: center;\n  margin-top: -68px;\n  padding: 0 20px;\n  position: relative;\n  z-index: 2;\n}\n\n.pro-avatar-wrap {\n  display: flex;\n  justify-content: center;\n  margin-bottom: 12px;\n}\n\n.pro-avatar-frame {\n  position: relative;\n  width: 120px;\n  height: 120px;\n  border-radius: 50%;\n  padding: 4px;\n  background: var(--pro-ring);\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);\n\n  ion-avatar {\n    width: 100%;\n    height: 100%;\n    margin: 0;\n  }\n}\n\n.pro-avatar-img {\n  width: 100%;\n  height: 100%;\n  border-radius: 50%;\n  object-fit: cover;\n  cursor: pointer;\n}\n\n.pro-avatar-placeholder {\n  width: 100%;\n  height: 100%;\n  border-radius: 50%;\n  background: var(--pro-card-bg);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  ion-icon {\n    width: 48px;\n    height: 48px;\n    opacity: 0.25;\n  }\n}\n\n.pro-online {\n  position: absolute;\n  bottom: 6px;\n  right: 6px;\n  width: 16px;\n  height: 16px;\n  border-radius: 50%;\n  background: #4ade80;\n  border: 3px solid #fff;\n}\n\n.pro-meta {\n  margin-bottom: 12px;\n}\n\n.pro-name {\n  font-size: 28px;\n  font-weight: 700;\n  color: var(--pro-name);\n  margin: 0 0 4px;\n  line-height: 1.15;\n  letter-spacing: -0.3px;\n  word-break: break-word;\n  text-align: center;\n}\n\n.pro-role {\n  font-size: 15px;\n  font-weight: 400;\n  color: var(--pro-body);\n  margin: 0;\n  opacity: 0.8;\n  line-height: 1.4;\n  word-break: break-word;\n  text-align: center;\n}\n\n.pro-social {\n  display: flex;\n  justify-content: center;\n  gap: 4px;\n  flex-wrap: wrap;\n  margin-bottom: 4px;\n}\n\n.pro-social-btn {\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  border: 1px solid var(--pro-primary);\n  background: transparent;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: background 0.2s ease, transform 0.2s ease;\n\n  &:hover {\n    background: color-mix(in srgb, var(--pro-primary) 10%, transparent);\n    transform: scale(1.12);\n  }\n\n  ion-icon {\n    width: 18px;\n    height: 18px;\n    color: var(--pro-primary);\n  }\n}\n\n.pro-body {\n  padding: 8px 16px 32px;\n  max-width: 640px;\n  margin: 0 auto;\n  animation: proFadeUp 0.35s ease both;\n}\n\n@keyframes proFadeUp {\n  from { opacity: 0; transform: translateY(10px); }\n  to { opacity: 1; transform: translateY(0); }\n}\n\n.pro-actions {\n  display: flex;\n  gap: 8px;\n  justify-content: center;\n  margin: 16px 0;\n  flex-wrap: wrap;\n}\n\n.pro-action-btn {\n  --border-color: var(--pro-primary);\n  --color: var(--pro-primary);\n  --border-radius: 24px;\n  font-weight: 500;\n  font-size: 14px;\n  min-height: 40px;\n  text-transform: none;\n  margin: 0;\n}\n\n.pro-section {\n  margin-top: 20px;\n}\n\n.pro-section + .pro-section {\n  position: relative;\n  padding-top: 20px;\n\n  &::before {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 50%;\n    transform: translateX(-50%);\n    width: calc(100% - 40px);\n    height: 1px;\n    background: var(--pro-body);\n    opacity: 0.12;\n  }\n}\n\n.pro-card {\n  background: #ffffff;\n  border-radius: 16px;\n  padding: 20px;\n  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);\n  border: 1px solid rgba(0, 0, 0, 0.04);\n}\n\n.pro-card-body {\n  font-size: 15px;\n  line-height: 1.65;\n  color: var(--pro-body);\n  font-weight: 400;\n\n  * {\n    max-width: 100%;\n    word-break: break-word;\n  }\n}\n\n.pro-card--inline {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 14px 20px;\n}\n\n.pro-inline-icon {\n  font-size: 20px;\n  color: var(--pro-primary);\n  flex-shrink: 0;\n}\n\n.pro-inline-link {\n  font-size: 14px;\n  color: var(--pro-btn-bg);\n  text-decoration: none;\n  word-break: break-all;\n\n  &:hover {\n    text-decoration: underline;\n  }\n}\n\n.pro-cf-list {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.pro-cf-item {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n}\n\n.pro-cf-icon {\n  flex-shrink: 0;\n  width: 20px;\n  height: 20px;\n  font-size: 20px;\n  color: var(--pro-primary);\n  margin-top: 2px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\ni.pro-cf-icon {\n  font-size: 20px;\n  font-style: normal;\n}\n\n.pro-cf-text {\n  flex: 1;\n  min-width: 0;\n}\n\n.pro-cf-label {\n  display: block;\n  font-size: 11px;\n  font-weight: 600;\n  color: var(--pro-body);\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n  margin-bottom: 2px;\n  opacity: 0.6;\n}\n\n.pro-cf-value {\n  font-size: 15px;\n  line-height: 1.4;\n  color: var(--pro-name);\n  font-weight: 500;\n  word-break: break-word;\n}\n\n.pro-doc-row {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  padding: 12px 0;\n  cursor: pointer;\n  transition: background 0.2s ease;\n\n  &:hover {\n    background: var(--pro-card-bg);\n    border-radius: 10px;\n    margin: 0 -8px;\n    padding: 12px 8px;\n  }\n}\n\n.pro-doc-row + .pro-doc-row {\n  border-top: 1px solid rgba(0, 0, 0, 0.04);\n}\n\n.pro-doc-icon {\n  flex-shrink: 0;\n  width: 40px;\n  height: 40px;\n  border-radius: 10px;\n  background: var(--pro-card-bg);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  img {\n    width: 22px;\n    height: 22px;\n    object-fit: contain;\n  }\n}\n\n.pro-doc-info {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 1px;\n}\n\n.pro-doc-name {\n  font-size: 14px;\n  font-weight: 500;\n  color: var(--pro-name);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.pro-doc-type {\n  font-size: 12px;\n  font-weight: 400;\n  color: var(--pro-body);\n  opacity: 0.6;\n}\n\n.pro-doc-arrow {\n  font-size: 16px;\n  color: var(--pro-body);\n  opacity: 0.3;\n  flex-shrink: 0;\n}\n\n.pro-att-row {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 10px 0;\n  cursor: pointer;\n  transition: background 0.2s ease;\n\n  &:hover {\n    background: var(--pro-card-bg);\n    border-radius: 10px;\n    padding: 10px 8px;\n    margin: 0 -8px;\n  }\n}\n\n.pro-att-row + .pro-att-row {\n  border-top: 1px solid rgba(0, 0, 0, 0.04);\n}\n\n.pro-att-avatar {\n  width: 44px;\n  height: 44px;\n  flex-shrink: 0;\n  margin: 0;\n}\n\n.pro-att-placeholder {\n  opacity: 0.4;\n}\n\n.pro-att-info {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.pro-att-name {\n  font-size: 15px;\n  font-weight: 600;\n  color: var(--pro-name);\n}\n\n.pro-att-role {\n  font-size: 13px;\n  color: var(--pro-body);\n  opacity: 0.7;\n}\n\n.pro-att-arrow {\n  font-size: 16px;\n  color: var(--pro-body);\n  opacity: 0.3;\n}\n\n.pro-sessions-card {\n  padding: 16px 20px;\n}\n\n.pro-session-date {\n  font-size: 12px;\n  font-weight: 600;\n  color: var(--pro-body);\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n  padding: 16px 0 8px;\n  opacity: 0.6;\n}\n\n.pro-session-row {\n  display: flex;\n  gap: 14px;\n  padding: 10px 0;\n  cursor: pointer;\n  border-left: 2px solid rgba(0, 0, 0, 0.06);\n  padding-left: 14px;\n  margin-left: 0;\n  transition: border-color 0.2s ease;\n\n  &:hover {\n    border-left-color: var(--pro-primary);\n  }\n}\n\n.pro-session-track-dot {\n  flex-shrink: 0;\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n  margin-top: 5px;\n}\n\n.pro-session-body {\n  flex: 1;\n  min-width: 0;\n}\n\n.pro-session-name {\n  font-size: 15px;\n  font-weight: 600;\n  color: var(--pro-name);\n  line-height: 1.3;\n}\n\n.pro-session-time {\n  font-size: 13px;\n  color: var(--pro-body);\n  opacity: 0.7;\n  margin-top: 2px;\n}\n\n.pro-session-location {\n  font-size: 12px;\n  color: var(--pro-btn-bg);\n  margin-top: 4px;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n\n  ion-icon {\n    width: 14px;\n    height: 14px;\n  }\n}\n\n.pro-loader {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 200px;\n}\n\n@media screen and (min-width: 768px) {\n  ::ng-deep ion-content {\n    --background: var(--pro-bg);\n  }\n\n  .pro-banner {\n    height: 160px;\n    border-radius: 0 0 40px 40px;\n  }\n\n  .pro-head {\n    margin-top: -88px;\n    padding: 0 40px;\n  }\n\n  .pro-avatar-frame {\n    width: 140px;\n    height: 140px;\n    padding: 5px;\n  }\n\n  .pro-avatar-placeholder ion-icon {\n    width: 56px;\n    height: 56px;\n  }\n\n  .pro-name {\n    font-size: 34px;\n  }\n\n  .pro-role {\n    font-size: 17px;\n  }\n\n  .pro-social {\n    gap: 6px;\n  }\n\n  .pro-social-btn {\n    width: 40px;\n    height: 40px;\n    border-width: 1.5px;\n\n    ion-icon {\n      width: 20px;\n      height: 20px;\n    }\n  }\n\n  .pro-body {\n    padding: 12px 40px 48px;\n    max-width: 720px;\n  }\n\n  .pro-card {\n    border-radius: 20px;\n    padding: 24px;\n    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);\n  }\n\n  .pro-cf-list {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 20px;\n  }\n\n  .pro-actions {\n    gap: 12px;\n  }\n\n  .pro-action-btn {\n    min-height: 44px;\n    font-size: 15px;\n  }\n\n  .pro-session-row {\n    padding: 12px 0 12px 16px;\n  }\n\n  .pro-session-name {\n    font-size: 16px;\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .pro-body {\n    animation: none;\n  }\n\n  .pro-social-btn,\n  .pro-doc-row,\n  .pro-att-row {\n    transition: none !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
